// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Isolation Units API
 * Manage isolation units, clusters and partitions.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  Cluster,
  ClusterListResponse,
  ErrorResponse,
  IsolationUnit,
  IsolationUnitListResponse,
  Partition,
  PartitionListResponse,
} from '../models/index';
import {
  ClusterFromJSON,
  ClusterToJSON,
  ClusterListResponseFromJSON,
  ClusterListResponseToJSON,
  ErrorResponseFromJSON,
  ErrorResponseToJSON,
  IsolationUnitFromJSON,
  IsolationUnitToJSON,
  IsolationUnitListResponseFromJSON,
  IsolationUnitListResponseToJSON,
  PartitionFromJSON,
  PartitionToJSON,
  PartitionListResponseFromJSON,
  PartitionListResponseToJSON,
} from '../models/index';

export interface V1ClustersIdGetRequest {
  id: string;
}

export interface V1IsolationunitsIdGetRequest {
  id: string;
}

export interface V1PartitionsIdGetRequest {
  id: string;
}

/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
  /**
   * List clusters
   */
  async v1ClustersGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ClusterListResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/clusters`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ClusterListResponseFromJSON(jsonValue),
    );
  }

  /**
   * List clusters
   */
  async v1ClustersGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ClusterListResponse> {
    const response = await this.v1ClustersGetRaw(initOverrides);
    return await response.value();
  }

  /**
   * Get a cluster
   */
  async v1ClustersIdGetRaw(
    requestParameters: V1ClustersIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Cluster>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1ClustersIdGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/clusters/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ClusterFromJSON(jsonValue),
    );
  }

  /**
   * Get a cluster
   */
  async v1ClustersIdGet(
    requestParameters: V1ClustersIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Cluster> {
    const response = await this.v1ClustersIdGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get all isolation units
   */
  async v1IsolationunitsGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IsolationUnitListResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/isolationunits`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      IsolationUnitListResponseFromJSON(jsonValue),
    );
  }

  /**
   * Get all isolation units
   */
  async v1IsolationunitsGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IsolationUnitListResponse> {
    const response = await this.v1IsolationunitsGetRaw(initOverrides);
    return await response.value();
  }

  /**
   * Get an isolation unit
   */
  async v1IsolationunitsIdGetRaw(
    requestParameters: V1IsolationunitsIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IsolationUnit>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1IsolationunitsIdGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/isolationunits/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      IsolationUnitFromJSON(jsonValue),
    );
  }

  /**
   * Get an isolation unit
   */
  async v1IsolationunitsIdGet(
    requestParameters: V1IsolationunitsIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IsolationUnit> {
    const response = await this.v1IsolationunitsIdGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * List partitions
   */
  async v1PartitionsGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PartitionListResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/partitions`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PartitionListResponseFromJSON(jsonValue),
    );
  }

  /**
   * List partitions
   */
  async v1PartitionsGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PartitionListResponse> {
    const response = await this.v1PartitionsGetRaw(initOverrides);
    return await response.value();
  }

  /**
   * Get a partition
   */
  async v1PartitionsIdGetRaw(
    requestParameters: V1PartitionsIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Partition>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1PartitionsIdGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/partitions/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PartitionFromJSON(jsonValue),
    );
  }

  /**
   * Get a partition
   */
  async v1PartitionsIdGet(
    requestParameters: V1PartitionsIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Partition> {
    const response = await this.v1PartitionsIdGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
